export default "__VITE_ASSET__ClLV06_h__"